import React from "react";
import { styled } from "@material-ui/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Modal, Button, Spin, Layout, message } from "antd";
import posed from "react-pose";
import "./iemaster.css";
import styles from "./iemaster.module.css";
import "../../files/common.css";
import Login from "../login/login.js";
import { loginAuth, fetchAuth, refreshTokenCycle, gotoWorkSite } from "../../util/auth.js";
import WaitBlock from '../../util/waitblock';

import {
  RESPONSE_STATUS_NONE,
  RESPONSE_STATUS_OK,
  RESPONSE_STATUS_NO,
  RESPONSE_STATUS_ERROR
} from "../../../src/constants/Const";


const MyLoader = styled(CircularProgress)({
  marginTop: "10%",
  margin: 0,
  color: "#ef7f30"
});

class IEMaster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        isLoading: false,
      isDisplayLoader: false,
      loaderText: "",
      isLogged: false,
      userName: null,
      isLoginVisible: false,
	  isWorkSiteOpening: false
    };

    this.exit = this.exit.bind(this);
    this.demoEnter = this.demoEnter.bind(this);
    this.setUser = this.setUser.bind(this);
    this.login = this.login.bind(this);
    this.recoverPassword = this.recoverPassword.bind(this);
  }

  showModal = () => {
    this.setState({
      isWorkSiteOpening: true,
    });
  };
  
    exit = async () => {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };
        fetchAuth(window.configTI.URL_BACKEND + '/profile/exit', requestOptions)
            .then(data => {
                if (data.bodyStatus && (data.bodyStatus == 1 || data.bodyStatus == 4)) {
                    this.setUser(null, false);
                    message.success("Выход выполнен");
                }
                else if (data.bodyStatus && data.bodyStatus == 3) {
                    message.error(data.message);
                }
                else {
                    message.error('Ответ не получен.');
                }
            })
            .catch(error => {
                message.error('Ошибка:' + error);
                console.log(error);
            });

    };

    setUser = (user, isLogged) => {
        this.setState({ userName: user, isLogged: isLogged });
    };

    fToWorkSite = () => {
        if (this.state.isLogged) {
            gotoWorkSite(
                () => { },
                () => {
                    message.warn("Не удалось перейти на рабочий сайт");
                }
            )
        }
    }
    demoEnter = () => {
        var request = {
            User: window.configTI.DEMO_USER,
            Password: window.configTI.DEMO_PASSWORD
        };
        this.login(request);
    }

    //Вход в личный кабинет.
    //inputCredentials: {User: <userName>, Password: <password>}
    login = inputCredentials => {
        this.setState({ isLoading: true });
        loginAuth(window.configTI.URL_BACKEND + '/profile/login', inputCredentials.User, inputCredentials.Password)
            .then(data => {
                if (data.bodyStatus && data.bodyStatus == 1) {
                    const token = data.body.token;
                    if (token) {
                        this.setUser(token.login, true);
                        this.fToWorkSite();
                    }
                    else {
                        message.error('Системная ошибка при выполнении входа.');
                        this.setState({ isLoading: false });
                    }
                }
                else if (data.bodyStatus && (data.bodyStatus == 3 || data.bodyStatus == 2)) {
                    message.error(data.message);
                    this.setState({ isLoading: false });
                }
                else {
                    message.error('Ответ не получен.');
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                message.error('Ошибка:' + error);
                this.setState({ isLoading: false });
                console.log(error);
            });
    };

    //Восстановление пароля.
    recoverPassword = userName => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(userName)
        };
        fetch(window.configTI.URL_BACKEND + '/profile/pswrecover', requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.bodyStatus && data.bodyStatus == 1) {
                    const result = data.body;
                    if (result) {
                        //!!!!! При таком способе восстановления пароля. Пароль может быть сброшен любым пользователем
                        //для другого пользователя, который получит его на свою почту (и может об этом не узнать).
                        //Нормально отправлять промежуточный код восстановления на почту и по промежуточной ссылке 
                        //сбрасывать пароль.
                        message.success("На Вашу почту отправлен новый пароль.");
                    }
                    else {
                        message.success("Автоматически восстановить пароль не удалось. Для восстановления пароля обратитесь в службу поддержки.");
                    }
                }
                else if (data.bodyStatus && data.bodyStatus == 3) {
                    message.error(data.message);
                }
                else {
                    message.error('Ответ не получен.');
                }
            })
            .catch(error => {
                message.error('Ошибка:' + error);
                console.log(error);
            });
    };


  render() {
    return (
        <React.Fragment>
            { this.state.isLoading && <WaitBlock />}
      <Layout
        style={{
          height: "100%",
          width: "100%",
          backgroundColor: "white",
          position: "relative"
        }}
      >
        <Modal
          title="Переход в личный кабинет"
          visible={this.state.isWorkSiteOpening}
		  footer={null}
        >
			<Spin size="large" />
        </Modal>
        <div
          style={{
            position: "absolute",
            top: "30.5%",
            left: "46.89%",
            display: this.state.isDisplayLoader ? "initial" : "none",
            zIndex: "2000"
          }}
        >
          <MyLoader size="8em" variant="indeterminate" disableShrink={true}/>
        </div>

		<div style={{fontSize:"18pt", paddingRight:"100px", paddingLeft:"100px", color:"orange"}} align="center">
   	К сожалению, сайт не может полноценно работать в браузере Internet Explorer.
	Установите, пожалуйста, другой браузер: <a href="https://www.mozilla.org/ru/firefox/new/">Firefox</a>, <a href="https://www.google.com/intl/ru/chrome/">Chrome</a>,  <a href="https://browser.yandex.ru/">Yandex</a>,  <a href="https://www.apple.com/ru/safari/">Safari</a> или <a href="https://www.opera.com/ru"> Opera</a>.
	</div>
        <div>
              <Login
                login={this.login}
                recoverPassword={this.recoverPassword}
                demoEnter={this.demoEnter}
              />
        </div>
      </Layout>
    </React.Fragment>
    );
    }
}

export default IEMaster;
